/** Shown for a moment while a dashboard page loads its data. */
export function AdminLoading() {
  return (
    <div role="status" aria-live="polite" className="flex flex-col gap-4 py-2">
      <span className="sr-only">Loading…</span>
      <div className="h-10 w-48 animate-pulse rounded-lg bg-midnight/10" />
      <div className="h-32 animate-pulse rounded-2xl bg-midnight/5" />
      <div className="h-32 animate-pulse rounded-2xl bg-midnight/5" />
    </div>
  );
}
